import React, { useEffect, useRef, useState } from "react";
import Search from "../../../../../../components/Search";
import { useDispatch, useSelector } from "react-redux";
import { Divider, Dropdown, Form, Select, Table } from "antd";
import svg27 from "../../../../../../assets/svg/svg27.svg";
import svg12 from "../../../../../../assets/svg/svg12.svg";
import svg15 from "../../../../../../assets/svg/svg15.svg";
import { Link, useNavigate } from "react-router-dom";
import CardLoading from "../../../../../../components/CardLoading";
import { GenderData } from "../../../../../../data";
import MembersView from "./MembersView";
import {
  fetchData,
  fetchPeriods,
} from "../../../../../../features/fetch/fetchSlice";
import { cashConverter } from "../../../../../../utils";

function FarmInputTable() {
  const [form] = Form.useForm();
  const formRef = useRef(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const url = "prod/get_production_details";
  const { loading, data, count, periods } = useSelector((state) => ({
    loading: state.fetch.loading,
    data: state.fetch.data[url] || [],
    count: state.fetch.count[url] || 0,
    periods: state.fetch.periods,
  }));
  const { activeObjSchemes, iwuaObj } = useSelector((state) => ({
    activeObjSchemes: state.obj.activeObj["schemes"],
    iwuaObj: state.obj.iwuaObj,
  }));
  const { refetchKey } = useSelector((state) => state.global);
  const [searchInput, setsearchInput] = useState(null);
  const [prodd, setProdd] = useState("");

  const [openDrawer, setOpenDrawer] = useState(false);
  const showDrawer = () => {
    setOpenDrawer(true);
  };
  const onClose = () => {
    setOpenDrawer(false);
  };

  const handleSearch = (e) => {
    setsearchInput(e.target.value);
    dispatch(
      fetchData({
        url: url,
        usrFirstname: e.target.value == "" ? null : e.target.value,
        proSchId: activeObjSchemes?.schId,
        start: 0,
        limit: null,
      })
    );
  };

  const handleEdit = async () => {
    await navigate("/iwua-member-add");
  };
  const handleDisable = () => {};
  const handleAdd = async () => {
    await navigate("/iwua-member-add");
  };
  const handleView = async (item) => {
    await setProdd(item);
    await dispatch(
      fetchData({
        url: "prod/get_member",
        limit: null,
        start: 0,
        usrInstId: iwuaObj?.instId,
        usrId: item?.prodUsrId,
      })
    );
    await showDrawer();
  };

  const settingItems = [
    {
      key: "1",
      label: (
        <div onClick={handleEdit}>
          <Link className="flex actions-text gap-x-[.75rem] my-2 ">
            <img src={svg12} alt="svg12" /> Edit
          </Link>
          <div className="mt-[1rem]">
            <Divider />
          </div>
        </div>
      ),
    },
    {
      key: "2",
      label: (
        <div onClick={handleView}>
          <Link className="flex actions-text gap-x-[.75rem] my-2 ">
            <img src={svg15} alt="svg15" /> View
          </Link>
        </div>
      ),
    },
  ];
 
  const columns = [
    {
      title: "#",
      dataIndex: "index",
      key: "index",
      render: (_, record, index) => {
        if (record?.isGroup) {
          return {
            children: (
              <div className="scheme-custom-header">{record?.prodCrops}</div>
            ),
            props: { colSpan: columns?.length },
          };
        }

        let num = 1;
        for (let i = 0; i < index; i++) {
          if (data[i].isGroup) {
            num = 1;
          } else {
            num++;
          }
        }
        return num;
      },
    },
    {
      title: "Name",
      dataIndex: "prodFarmer",
      render: (_, record) => (record?.isGroup ? {} : _),
    },
    {
      title: "Block",
      dataIndex: "prodBlocks",
      render: (_, record) => (record.isGroup ? { props: { colSpan: 0 } } : _),
    },
    {
      title: "Farm Size",
      dataIndex: "prodFarmSize",
      render: (_, record) => (record.isGroup ? { props: { colSpan: 0 } } : _),
    },
    {
      title: "Cropped Area",
      dataIndex: "prodCroppedArea",
      render: (_, record) => (record.isGroup ? { props: { colSpan: 0 } } : _),
    },
    {
      title: "Water Source",
      dataIndex: "prodWaterSource",
      render: (_, record) => (record.isGroup ? { props: { colSpan: 0 } } : _),
    },
    {
      title: "Type/Name of seeds",
      dataIndex: "prodSeedType",
      render: (_, record) => (record.isGroup ? { props: { colSpan: 0 } } : _),
    }, 
    {
      title: "Seed (Kg)",
      dataIndex: "prodSeedKg",
      render: (_, record) => (record.isGroup ? { props: { colSpan: 0 } } : _),
    },
    {
      title: "Cost Per (Kg)",
      dataIndex: "prodSeedCost",
      render: (_, record) => (record.isGroup ? { props: { colSpan: 0 } } : _),
    },
    {
      title: "Fertilizer Type",
      dataIndex: "prodFertType",
      render: (_, record) => (record.isGroup ? { props: { colSpan: 0 } } : _),
    },
    {
      title: "Fertilizer (Kg)",
      dataIndex: "prodFertSize",
      render: (_, record) => (record.isGroup ? { props: { colSpan: 0 } } : _),
    },
    {
      title: "Land preparation Cost (kes)",
      dataIndex: "prodLandCost",
      render: (item, record) => {
        if (record.isGroup) {
          return { props: { colSpan: 0 } };
        }
        return <div>{cashConverter(item)}</div>;  
      }  
    },
    {
      title: "Total Herbicides Cost (kes)",
      dataIndex: "prodHerbCost",
      render: (item, record) => {
        if (record.isGroup) {
          return { props: { colSpan: 0 } };
        }
        return <div>{cashConverter(item)}</div>;  
      }  
    },
    {
      title: "Total Cost",
      dataIndex: "prodTotalCost",
      render: (item, record) => {
        if (record.isGroup) {
          return { props: { colSpan: 0 } };
        }
        return <div>{cashConverter(item)}</div>;  
      } 
    },
    {
      title: "Actions",
      render: (item, record) => {
        if (record.isGroup) return { props: { colSpan: 0 } };
        return (
          <>
           <button onClick={() => handleView(item)}>
              <img src={svg15} alt="View" />
            </button>
          </>
        );
      },
    },
  ];

  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [periodId, setPeriodId] = useState(periods?.length > 0 ? periods?.[0]?.proId : null);

  async function fetchFarmInputData(page, size) {
    await dispatch(
      fetchData({
        url: url,
        proSchId: activeObjSchemes?.schId,
        prodProId: periodId,
        prodType: "FARM_INPUT_DATA",
        limit: size ?? pageSize,
        start: page ?? pageIndex,
      })
    );
  }

  useEffect(() => {
    if (refetchKey == 5) {
      fetchFarmInputData();
    }
  }, [refetchKey, periodId]);
  useEffect(() => {
    if (refetchKey == 5) {
      dispatch(
        fetchPeriods({
          proSchId: activeObjSchemes?.schId,
        })
      );
    }
  }, [refetchKey]);

  const dataSource = [
    { key: "group-rice", name: "Rice", isGroup: true, seedType: "Basmati 370" },
    {
      key: "1",
      name: "Abubakar Muindi",
      block: "A",
      farmSize: "5 Acres",
      croppedArea: "3 Acres",
      waterSource: "Canal",
      seedType: "Basmati 370",
      weight: "87 Kg",
      herbicides: "Butachlor",
      fertilizer: "DAP, Urea...",
      yield: "187,121 Kg",
    },
    {
      key: "2",
      name: "Abubakar Muindi",
      block: "G",
      farmSize: "3 Acres",
      croppedArea: "3 Acres",
      waterSource: "Canal",
      seedType: "Basmati 370",
      weight: "87 Kg",
      herbicides: "Butachlor",
      fertilizer: "DAP, Urea...",
      yield: "187,121 Kg",
    },
    { key: "group-wheat", name: "Wheat", isGroup: true },
    {
      key: "3",
      name: "Abubakar Muindi",
      block: "B",
      farmSize: "3 Acres",
      croppedArea: "3 Acres",
      waterSource: "Canal",
      seedType: "Basmati 370",
      weight: "87 Kg",
      herbicides: "Butachlor",
      fertilizer: "DAP, Urea...",
      yield: "187,121 Kg",
    },
    {
      key: "4",
      name: "Abubakar Muindi",
      block: "C",
      farmSize: "5 Acres",
      croppedArea: "3 Acres",
      waterSource: "Canal",
      seedType: "Basmati 370",
      weight: "87 Kg",
      herbicides: "Butachlor",
      fertilizer: "DAP, Urea...",
      yield: "187,121 Kg",
    },
  ];

  const onFinish = () => {};

  if (loading && !searchInput) return <CardLoading />;
  return (
    <div className="lg:min-h-[88vh] flex flex-col">
      <div className="flex flex-col   lg:px-[1.25rem] flex-1   ">
        <div className="  mt-[1.25rem]">
          <Form
            layout="vertical"
            ref={formRef}
            name="control-ref"
            onFinish={onFinish}
            className="w-full lg:w-[40%]"
            form={form}
          >
            <div className="w-full flex items-center gap-x-[.5rem] text-[#6B7280] text-[.875rem] font-[400] font-interSans">
              <span className="">Select Period</span>
              <Select 
                className=""
                allowClear
                style={{
                  width: "100%",
                }}
                options={
                  periods?.length > 0 &&
                  periods?.map((item) => ({
                    value: item?.proId,
                    label: item?.proPeriod,
                  }))
                }
                value={periodId}
                onChange={(value) => setPeriodId(value)}
                showSearch
                optionFilterProp="children"
                filterOption={(input, option) =>
                  (option?.label?.toLocaleLowerCase() ?? "").includes(
                    input?.toLocaleLowerCase()
                  )
                }
              />
            </div>
          </Form>
        </div>
        <Table
          rowSelection={false}
          rowClassName={(record) => (record.isGroup ? "group-row" : "")}
          bordered={false}
          pagination={{
            position: ["bottomRight"],
            current: pageIndex + 1,
            total: count,
            pageSize: pageSize,
            onChange: (page, size) => {
              setPageIndex(page - 1);
              setPageSize(size);
              fetchFarmInputData(page - 1, size);
            },
            showSizeChanger: false,
            hideOnSinglePage: true,
          }}
          rowKey={(record) => record?.prodId}
          columns={columns}
          dataSource={data}
          scroll={{ x: 1200 }}
          className="mt-[1.94rem] custom-tables"
          loading={loading}
        />
      </div>
      <MembersView onClose={onClose} open={openDrawer} />
    </div>
  );
}

export default FarmInputTable;
